import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { NotaFiscalDevolucao } from "app/types/pesquisa-orcamento/consultas/Devolucoes";
import { CreditoDevolucoes } from "app/types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/CreditoDevolucoes";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { DevolucoesFinanceiro } from "./DevolucoesFinanceiro";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { useMenuSubConsultasDevolucoes } from "app/components/pesquisa-orcamento/menu-sub-consultas-devolucoes/useMenuSubConsultasDevolucoes";
import { useMenuConsultasPesquisaOrcamento } from "app/components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";

export type DevolucoesFinanceiroContainerProps = {
    devolucaoSelecionada: Partial<NotaFiscalDevolucao>;
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
}

export const DevolucoesFinanceiroContainer = (props: DevolucoesFinanceiroContainerProps) => {

    const [dados, setDados] = useState<CreditoDevolucoes[]>([]);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosFinanceiro = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalEntrada.CreditoDevolucao(
                Number(props.devolucaoSelecionada.Codigo)
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }
            
            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.remove("Devoluções").map)),
    })

    useMenuSubConsultasDevolucoes({
        devolucaoSelecionada: props.devolucaoSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => props.onVoltar(),
        passos: props.passos
    })

    useEffect(() => {
        passosInterno.current.set("Devoluções", () => props.onVoltar())
        passosInterno.current.set("Financeiro", () => { })
        onObterDadosFinanceiro();
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="DevolucoesFinanceiroContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={() => onVoltar()}
            />
            
            <DevolucoesFinanceiro dadosfincaneiro={dados} />
        </>
    )
}